import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { PartnerWorkflowStatus } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'
import { I406Form } from 'clickNgo/models/crud/forms/i406Form'
import { CrudStore } from 'core/types/crudStore'

import { PartnerServiceOptions } from '../configs'
import { mapPartnerFrom406Crud } from '../mapping/mapPartnerFrom406Crud'

type Params = {
  EntryId: number
  WorkflowStatus: PartnerWorkflowStatus
  ProfileApproverComment: string
}

export const updateBasicPartnerRequestStatus = (params: Params): Promise<Partial<IPartner>> => {
  const source = CrudStore.get(CrudStoreItem.PartnerAllData, 'update-partners-ext')

  return source
    .update(PartnerServiceOptions.PARTNERS_EXT, [params])
    .then(([result]: I406Form[]) => result && mapPartnerFrom406Crud(result))
}
